import { Link } from "react-router-dom";

const STEPS = [
  {
    num: "01",
    icon: "ri-vip-diamond-line",
    title: "Invest in Your Villa or Cottage",
    desc: "Choose the unit that fits your goals and secure your ownership.",
  },
  {
    num: "02",
    icon: "ri-home-smile-line",
    title: "Enjoy Personal Holiday Stays",
    desc: "Your retreat is always waiting for you and your family.",
  },
  {
    num: "03",
    icon: "ri-user-star-line",
    title: "Rent It Through Professional Management",
    desc: "Our team handles marketing, bookings and guest experience.",
  },
  {
    num: "04",
    icon: "ri-money-cny-circle-line",
    title: "Generate Passive Income",
    desc: "Receive recurring rental returns without the day-to-day work.",
  },
  {
    num: "05",
    icon: "ri-line-chart-line",
    title: "Benefit From Long-Term Appreciation",
    desc: "Watch your asset grow in value over the years.",
  },
];

export default function InvestmentModel() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-primary-800 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20forest%20canopy%20seen%20from%20inside%20a%20luxury%20wooden%20cabin%20at%20dusk%2C%20tall%20pine%20trees%20silhouetted%2C%20soft%20warm%20glow%2C%20peaceful%20nature%20backdrop%2C%20deep%20green%20and%20dark%20tones%2C%20atmospheric%20minimalist%20composition&width=1800&height=1000&seq=model-nomad-bg-1&orientation=landscape"
          alt="Forest canopy backdrop"
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      <div className="relative z-10 w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-accent-400">
            <i className="ri-route-line"></i> Simple Investment Model
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-background-50 mt-4 leading-tight">
            From Investment to <span className="italic text-accent-300">Income</span> in Five Steps
          </h2>
          <p className="text-background-100/85 text-sm md:text-base mt-4 leading-relaxed">
            A clear, guided journey from buying your villa to enjoying long-term returns.
          </p>
          <Link
            to="/investments"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-5 py-2.5 hover:bg-accent-600 transition-colors"
          >
            Start Your Investment Journey
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 mt-12 md:mt-16">
          {STEPS.map((step, i) => (
            <div key={step.num} className="relative flex flex-col items-center text-center rounded-2xl bg-primary-900/60 backdrop-blur-sm border border-background-50/10 p-5 md:p-6">
              <span className="flex items-center justify-center w-12 h-12 rounded-full bg-accent-500 text-background-50">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <span className="font-heading text-accent-400 text-2xl font-semibold mt-3">{step.num}</span>
              <h4 className="text-sm font-bold text-background-50 mt-2 leading-snug">{step.title}</h4>
              <p className="text-xs text-background-100/80 mt-2 leading-relaxed">{step.desc}</p>
              {i < STEPS.length - 1 && (
                <i className="hidden lg:block ri-arrow-right-line absolute top-1/2 -right-4 translate-x-1/2 -translate-y-1/2 text-accent-400/70"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}